<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-05 18:32:12
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-15 13:41:20
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/good/tableCells/commissionRateCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div v-if="multiType">
			<show-more-cell :key="+row.hasOpenCommissionRate " :row="row" :show="column.commissionShow"></show-more-cell>
		</div>
		<div v-else>
			<span class="fz-12">{{ row.commissionRate }}%</span>
			<span v-if="column.commissionShow" class="ml-10 cursor-pointer fz-12" :class="[!+row.hasOpenCommissionRate ? 'rate-color-b4' : 'rate-color-g5']" @click="setting()">{{ !+row.hasOpenCommissionRate ? '设为公开佣金' : '已设为公开佣金'  }}</span>
		</div>
	</div>
</template>
<script>
import showMoreCell from './showMoreCell.vue';
import mixin from '@/components/tableCells/mixin.js';

export default {
	inject: {
		injectSettingComssion: {
			default: () => {
				return () => {};
			},
		},
	},
	mixins: [mixin],
	data() {
		return {};
	},
	components: {
		showMoreCell
	},
	computed: {
		multiType(){
			return this.row.type;
		}
	},
	props: {},

	mounted() {},

	methods: {
		setting(){
			if(+this.row.hasOpenCommissionRate){
				return
			}
			this.injectSettingComssion(this.row)
		}
	},
};
</script>
<style lang="less" scoped>
.rate-color-b4{
	color: @color-b4
}
.rate-color-g5{
	color: #0C9F1B;
}
</style>
